import React from "react";
import "./App.css";
import logo from "./mlmLogo.png";
import covid from "./img/covid.jpg";
import pokemon from "./img/pokemon.jpg";
import tweets from "./img/tweets.jpg";
import twittericon from "./img/twitter.png";
import linkedin from "./img/linkedin.png";
import github from "./img/githubwhite.png";
import shell from "./img/shellWhite.png";
import bottle from "./img/bottleWhite.png";

function App() {
  return (
    <div id="page-top">
      <nav
        className="navbar navbar-expand-lg navbar-light fixed-top py-3"
        id="mainNav"
      >
        <div className="container">
          {/* <button
            className="navbar-toggler navbar-toggler-right"
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button> */}
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ml-auto my-2 my-lg-0">
              <li className="nav-item">
                <a className="nav-link js-scroll-trigger" href="#about">
                  About
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll-trigger" href="#services">
                  Skills
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll-trigger" href="#portfolio">
                  Portfolio
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll-trigger" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <header className="masthead">
        <div className="container h-100">
          <div className="row h-100 align-items-center justify-content-center text-center">
            <div className="col-lg-10 align-self-end">
              <h1
                id="mastheadh1"
                className="text-uppercase text-white font-weight-bold"
              >
                Maria Liza Martinez
              </h1>
              <hr className="divider my-4" />
            </div>
            <div className="col-lg-8 align-self-baseline">
              <p className="text-white-75 font-weight-light mb-5">
                Fullstack Engineer | UX/UI
              </p>
              <a
                className="btn btn-primary btn-xl js-scroll-trigger shake"
                href="#about"
              >
                Dive In
              </a>
            </div>
          </div>
        </div>
      </header>

      <section className="page-section bg-primary" id="about">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 id="aboutMe" className="mt-0">
                About Me
              </h2>
              <hr className="divider light my-4" />
              <p className="text-white-50 mb-4">
                Caribbean born, New York City based.
                <br />
                <br />
                I'm passionate about programming, especially building beautiful
                applications that are both user-friendly and accessible for all.
                <br />
                <br />
                Currently enrolled in an intensive 12-month, Google-funded
                software engineering fellowship with a 9% acceptance rate, at{" "}
                <a href="https://www.pursuit.org/">Pursuit </a>in Long Island
                City, Queens. I graduated with a BFA in film and tv,
                specializing in traditional animation and I'm thrilled to bring
                my creativity and artistic background to web development.
                <br />
                <br />
                I'm also a professional baker and chocolatier and dabble all
                over the visual arts spectrum!
              </p>
              <a
                className="btn btn-light btn-xl js-scroll-trigger shake"
                href="#services"
              >
                Check Out My Skills
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="page-section" id="services">
        <div className="container">
          <h2 className="mt-0">Skills</h2>
          <hr className="divider my-4" />

          <div className="row skillsRow">
            <div className="col-lg-3 col-md-6 text-center">
              <div className="mt-5">
                <p className="text-muted mb-0">
                  <img
                    id="jshtmlcss"
                    className="skillsIcons4 shake"
                    src="https://www.juicymedia.co.uk/application/files/4615/1838/4923/html_css_js.png"
                    alt="javascript icon"
                  />
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 text-center">
              <div className="mt-5">
                <p className="text-muted mb-0">
                  <img
                    id="react"
                    className="skillsIcons1 shake"
                    src="https://www.cloudanalogy.co.uk/wp-content/uploads/2019/06/react.png"
                    alt="react icon"
                  />
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 text-center">
              <div className="mt-5">
                <p className="text-muted mb-0">
                  <img
                    className="skillsIcons0 shake"
                    src="https://codedistrict.io/wp-content/uploads/2017/12/reduxLogo.png"
                    alt="redux icon"
                  />
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 text-center">
              <div className="mt-5">
                <p className="text-muted mb-0">
                  <img
                    id="pman"
                    className="skillsIcons1 shake"
                    src="https://cdn.shortpixel.ai/client/q_glossy,ret_img,w_634/https://huddle.eurostarsoftwaretesting.com/wp-content/uploads/2018/10/pm-logo-vert.png"
                    alt="postman icon"
                  />
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 text-center">
              <div className="mt-5">
                <p className="text-muted mb-0">
                  <img
                    id="node"
                    className="skillsIcons shake"
                    src="https://transang.me/content/images/2019/11/ExpressJS.png"
                    alt="express icon"
                  />
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 text-center">
              <div className="mt-5">
                <p className="text-muted mb-0">
                  <img
                    className="skillsIcons1 shake"
                    src="https://cdn.iconscout.com/icon/free/png-256/postgresql-11-1175122.png"
                    alt="postgresql icon"
                  />
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 text-center">
              <div className="mt-5">
                <p className="text-muted mb-0">
                  <img
                    id="node"
                    className="skillsIcons3 shake"
                    src="https://pluspng.com/img-png/nodejs-png-node-js-on-light-background-1843.png"
                    alt="node icon"
                  />
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 text-center">
              <div className="mt-5">
                <p className="text-muted mb-0">
                  <img
                    id="git"
                    className="skillsIcons3 shake"
                    src="https://git-scm.com/images/logos/downloads/Git-Logo-2Color.png"
                    alt="git icon"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <a
        id="projectBtn"
        className="btn btn-primary btn-xl js-scroll-trigger shake"
        href="#portfolio"
      >
        Projects
      </a>

      <section id="portfolio" className="page-section">
        <h2 id="portfolioH1" className="text-center mt-0">
          Portfolio
        </h2>
        <hr className="divider my-4" />
        <div className="container-fluid p-0">
          <div className="row no-gutters">
            <div className="col-lg-4 col-sm-6 text-center">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="portfolio-box"
                href="https://getyourpokemon.netlify.app/"
              >
                <img className="img-fluid" src={pokemon} alt="" />{" "}
              </a>
              <div className="portfolio-box-caption">
                <div id="category" className="project-category shake">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="portfolio-box"
                    href="https://getyourpokemon.netlify.app/"
                  >
                    Get Your Pokemon!
                  </a>
                  <a
                    href="https://github.com/mariaLiza/Unit4AssessmentPokemon"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="text-end small project-name">See the code!</p>
                  </a>
                </div>
                <div className="project-name">
                  A simple frontend React application, utilizing a restful API
                  to select pokemon by type. The user then chooses a pokemon to
                  view and learn about its stats
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 text-center">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="portfolio-box"
                href="https://covidnearus.netlify.app/"
              >
                <img id="covid" className="img-fluid" src={covid} alt="" />{" "}
              </a>
              <div className="portfolio-box-caption">
                <div id="category" className="project-category shake">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="portfolio-box"
                    href="https://covidnearus.netlify.app/"
                  >
                    COVIDNearUS
                  </a>
                  <a
                    href="https://github.com/mariaLiza/COVID-Hackathon"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="text-end small project-name">See the code!</p>
                  </a>
                </div>
                <div className="project-name">
                  A Covid-19 tracking React app created for Codecademy sponsored
                  48HR-Hackathon! Users can look up state-specific covid
                  information, view tweets and news feed, and find testing
                  locations nearby. Winner of Most Ambitious award from
                  Codecademy judges!
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 text-center">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="portfolio-box"
                href={"https://maria-martinez-cta.netlify.app/"}
              >
                <img id="tweet" className="img-fluid" src={tweets} alt="" />
              </a>
              <div className="portfolio-box-caption">
                <div id="category" className="project-category shake">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="portfolio-box"
                    href={"https://maria-martinez-cta.netlify.app/"}
                  >
                    Twitter-Twin
                  </a>
                  <a
                    href={"https://github.com/mariaLiza/twitter-twin"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="text-end small project-name">See the code!</p>
                  </a>
                </div>
                <div className="project-name">
                  Fullstack React app, where a user may sign up and log in to
                  their account using Google Firebase, view and create posts,
                  check out featured user profiles, and search posts by hashtag.{" "}
                  <br />
                  Future implementation: photo upload for profile picture, a work in progress
                  made with love
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          id="contactBtn"
          className="btn btn-light btn-xl js-scroll-trigger shake"
          href="#contact"
        >
          Contact Me
        </a>
      </section>

      <section className="page-section" id="contact">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="mt-0">Let's Get In Touch!</h2>
              <hr className="divider light my-4" />
              <p className="text-muted mb-5">
                I'd love to hear from you! Please feel free to call or send an
                email and I'll get back to you as soon as possible!
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 ml-auto text-center mb-5 mb-lg-0">
              <img
              id="seeMe"
                // style={{ width: "100px", padding: "10px" }}
                src={shell}
                alt="conch shell"
                className="fas fa-phone fa-3x mb-3 text-muted"
              />
              <div id="phone">+1 (646) 349-0455</div>
            </div>
            <div className="col-lg-4 mr-auto text-center">
              <img
              id="seeMe"
                // style={{ width: "100px" }}
                src={bottle}
                alt="message in a bottle"
                className="fas fa-envelope fa-3x mb-3 text-muted"
              />

              <a className="d-block" href="mailto:mariamartinez@pursuit.org">
                mariamartinez@pursuit.org
              </a>
            </div>
          </div>
        </div>
      </section>

      <div className="contactRow">
        <ul className="row">
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://twitter.com/xomarializaxo"
            >
              <img
                id="twit"
                className="contactIcons"
                src={twittericon}
                alt="twittericon"
              />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/marializamartinez/"
            >
              <img
                id="linkd"
                className="contactIcons"
                src={linkedin}
                alt="linkedin"
              />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/mariaLiza"
            >
              <img id="gh" className="contactIcons" src={github} alt="github" />
            </a>
          </li>
        </ul>
      </div>

      <footer className="bg-light py-5">
        <div className="container">
          <div className="small text-center text-muted">
            Copyright © 2020 Maria Liza Martinez
            <img src={logo} style={{ width: "100px" }} alt="mlm" />
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
